import React, { useState } from 'react';
import RobotDesigner from '../components/RobotDesigner';
import CodeEditor    from '../components/CodeEditor';
import Simulator     from '../components/Simulator';
import { Button, Stack, Typography, Divider } from '@mui/material';

export default function RobotPlayground() {
  const [parts, setParts]           = useState([]);
  const [selectedPartType, setSelectedPartType] = useState(null);
  const [codeText, setCodeText]     = useState(`// e.g.
// forward(100);
// turnLeft(90);
// forward(50);
// wait(500);
`);
  const [runCommands, setRunCommands] = useState([]);

  // parse codeText into [{fn,args},...]
  const parseCommands = txt => {
    const cmds = [];
    txt.split('\n').forEach(line => {
      const m = line.match(/\s*(\w+)\s*\(\s*([0-9]+)\s*\)/);
      if (m) cmds.push({ fn: m[1], arg: Number(m[2]) });
    });
    return cmds;
  };

  return (
    <div style={{ padding: 16 }}>
      <Typography variant="h4" gutterBottom>1) Design Your Robot</Typography>
      <Stack direction="row" spacing={2} alignItems="flex-start">
        <Stack spacing={1} sx={{ width: 140 }}>
          {['Body','Wheel','Arm','Sensor'].map(pt => (
            <Button
              key={pt}
              variant={selectedPartType===pt?'contained':'outlined'}
              onClick={()=>setSelectedPartType(pt)}
            >
              {pt}
            </Button>
          ))}
          <Button color="error" onClick={()=>setParts([])}>Clear All</Button>
        </Stack>
        <RobotDesigner
          parts={parts}
          selectedPartType={selectedPartType}
          onChangeParts={setParts}
        />
      </Stack>

      <Divider sx={{ my:4 }}/>
      <Typography variant="h4" gutterBottom>2) Program It</Typography>
      <CodeEditor value={codeText} onChange={setCodeText}/>
      <Button
        sx={{ mt:2 }}
        variant="contained"
        onClick={() => setRunCommands(parseCommands(codeText))}
      >
        Parse & Run
      </Button>

      <Divider sx={{ my:4 }}/>
      <Typography variant="h4" gutterBottom>3) Simulate</Typography>
      <Simulator parts={parts} commands={runCommands}/>
    </div>
  );
}
